import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class Sticky extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._closeButton = this._elem.querySelector('[data-sticky-container-close]')
    this._body = document.querySelector('body')
  }

  mount () {
    let currentTime = new Date().getTime()

    this._closeButton.addEventListener('click', e => {
      this._elem.style.height = `${this._elem.clientHeight}px`
      this._body.style.paddingBottom = `0px`
      let newEpoch1 = currentTime + (1000 * 60 * 60 * 24 * this._options.daysToHide)
      document.body.classList.add('can-transition')
      localStorage.setItem('ffc--sticky-container-closed', newEpoch1);

      Helpers.nextFrame(() => {
        let height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'))
        let newHeight = height - this._elem.clientHeight
        document.documentElement.style.setProperty('--header-height',`${newHeight}px`)

        let transitionEnd = () => {
          this._ctx.emit('ffc--sticky-refresh')
          this._elem.removeEventListener('transitionend', transitionEnd)
        }
        
        this._elem.addEventListener('transitionend', transitionEnd)

        this._elem.style.height = `0px`;
      })      
    })

    let shouldShow = true

    if (localStorage.getItem('ffc--sticky-container-closed')) {
      let epoch = localStorage.getItem('ffc--sticky-container-closed')
      if (epoch > currentTime) {
        shouldShow = false
      }
    }

    if (shouldShow) {
      this._elem.classList.add('shown')
      this._ctx.emit('ffc--update-css-var', null, {})
      this._ctx.emit('ffc--sticky-refresh')
      this._body.style.paddingBottom = `${this._elem.clientHeight}px`
    }
  }
}